module.exports = __webpack_public_path__ + "static/media/hup-image.d9b68929.jpeg";